/**
 * PATH: apps/inventory/src/pages/TransfersPage.tsx
 * PURPOSE: Stock transfers between locations
 */
import { EmptyRegister } from './emptyRegister'

export default function TransfersPage() {
  return (
    <EmptyRegister
      title="Stock Transfers"
      detail="No stock transfers are connected."
    />
  )
}
